import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

// 获取门店列表
export const getShopsApi = (params: object = {}) => $http.get('/admin/shops/getShopList', params)

// 根据品牌获取门店列表
export const getShopListByBrandApi = (brand_id, city_id = '') => $http.get('/distribution/listShopByBrand', { brand_id, city_id })

// 获取已通过审核门店详情
export const getShopDetailApi = (id: any) => $http.post('/admin/shops/getShopInfo', {id})

// 获取未审核/提交门店详情
export const getLocalShopDetailApi = (id: any) => $http.post('/admin/shops/getShopApprovalInfo', {id})

// 上架、下架门店
export const updateShopStatusAPi = (data: object) => $http.get('/admin/shops/saveShopStatus', data)


// 工作人员上架、下架门店
export const StaffupdateShopStatusAPi = (data: object) => $http.get('/admin/shops/kfSaveShopStatus', data)


// 获取门店审核列表
export const getCheckShopsApi = (params: object = {}) => $http.get('/admin/shops/getShopApprovalList', params)

// 获取门店批量上传模板
export const getBatchShopTplApi = (brand_ids: string) => $http.post('/admin/shops/getShopMb', {brand_ids})

// 门店批量上传
export const batchShopUploadApi = (brand_ids: number) => $http.post('/admin/shops/importShop', {brand_ids})

// 批量上传列表
export const getConfirmListApi = (product_id: any) => $http.get('/admin/shops/getBatchUploadList', {product_id})

// 删除批量上传记录
export const delUploadShopApi = (data: object) => $http.post('/admin/shops/delShopApproval', data)

// 门店审核详情
export const getCheckShopDetailApi = (data: object) => $http.post('/admin/shops/getShopApprovalInfo', data)

// 通过、驳回门店审核
export const saveCheckApi = (data: object) => $http.post('/admin/shops/saveShopApprovalStatus', data)

// 新增、编辑门店
export const saveShopApi = (data: object) => $http.post('/admin/shops/sendShopApproval', data)

// 工作人员新增、编辑门店
export const staffSaveShopApi = (data: object) => $http.post('/admin/shops/kfSendShopApproval', data)


/**
 * 根据订单ID获取可接单门店列表 -- 5条
 * 返回列表包含距离订单中收货地址的距离
 * */
export const getPickShopListApi = (order_id: number) => $http.get('/ptapi/order/get_shop_list', {order_id})

/**
 * 根据订单ID获取可分配门店（此类门店关联了门店账号）列表 -- 5条
 * 返回列表包含距离订单中收货地址的距离
 * */
export const getDistributeShopListApi = (order_id: number) => $http.get('/ptapi/order/shop_user_list', {order_id})
